<script>
    import { ALASKA_URL, CONSUMER_NOTICES_URL, CONTACT_URL, PRIVACY_POLICY_URL } from "../helpers/contentLinks";
</script>
<footer>
    <div class="footer-nav">
        <a href={CONTACT_URL}>
            Help center
        </a>
        <a href={`${ALASKA_URL}?SITE_PREF=full&amp;cid=mobsite-home`}>
            Full site
        </a>
        <a
            href={CONSUMER_NOTICES_URL}
        >
            Legal
        </a>
        <a
            href={PRIVACY_POLICY_URL}
        >
            Privacy
        </a>
    </div>
    <div id="copyright">
        &copy; {new Date().getFullYear()} Alaska Airlines, Inc.
    </div>
</footer>

<style lang="scss">
    footer {
        font-size: 14px;
        flex-shrink: 0;
        background: var(--ds-basic-color-surface-neutral-subtle);
    }

    .footer-nav {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
    }

    a {
        font-weight: bold;
        text-decoration: none;
        color: var(--ds-advanced-color-hyperlink-text);
        font-size: 13px;
    }

    :global(a.focus-visible) {
        color: var(--ds-advanced-color-hyperlink-text-inverse);
    }

    #copyright {
        background: var(--ds-basic-color-brand-primary);
        color: var(--ds-basic-color-texticon-inverse);
        font-size: 0.8em;
        text-align: center;
        padding: 10px 0;
    }

    @media screen and (min-width: $ds-grid-breakpoint-md) {
        .footer-nav {
            max-width: var(--ds-grid-breakpoint-xl);
        }
    }
</style>
